export default __webpack_public_path__ + "static/sealedPicture-0f235515fe11ad9db052b5ae1ed7562c.png";